export const API_INIT_EVENT = 'init';

export const API_BAR_SERVICE_NAME = 'bar';
export const API_BAR_OPEN_METHOD_NAME = 'open';
export const API_BAR_CLOSE_METHOD_NAME = 'close';
